import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/Consultoria";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/consultoria")({
  head: () => pageHead({ title: "Consultoria nutricional | Clara Camille", path: "/consultoria", noindex: true }),
  component: Page,
});
